import { getIn } from 'formik';
import {
  ColorCode,
  Container,
  Image,
  Row,
  ColorWrapper,
  BottomContainer,
  Title,
  ColorCollection,
} from './ColorInput.styled';
import { IQuestion } from 'types/Question.types';
import Button from 'components/Button/Button';
import { useDispatch } from 'react-redux';
import { setTouchedQuestionName } from 'store/Form/actions/form';
import { useTranslation } from 'react-i18next';
import { setColorModalData } from 'store/ColorModal/actions/colorModal';
import { IColor } from 'components/Modals/ColorModal/ColorModal';
import { getChosenColorOptionFromQuestionOptions } from './helpers';
import { useValidateColorInput } from './hooks';
import { getContrastingLabelColor } from 'utils/colorUtils';
import ClearValueButton from 'components/ClearValueButton/ClearValueButton';

interface IColorInputProps {
  pwId: string;
  question: IQuestion;
  context: any;
  isTouched: boolean;
  showClear?: boolean;
  reserveClear?: boolean;
  onClear?: () => void;
}

const ColorInput = ({
  pwId,
  question,
  context,
  isTouched,
  showClear = false,
  reserveClear = false,
  onClear,
}: IColorInputProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const chosenColorValue: string | undefined = getIn(
    context.values,
    question.initialKey
  );
  const chosenColor: IColor | undefined =
    getChosenColorOptionFromQuestionOptions(chosenColorValue, question);
  // Without a hex code the labels keep the theme text color
  const labelColor = chosenColor?.hex_code
    ? getContrastingLabelColor(chosenColor.hex_code)
    : undefined;
  useValidateColorInput(question, context);

  return (
    <Container>
      <Button
        label={t('Choose')}
        primary
        width="150rem"
        onClick={() => {
          dispatch(setColorModalData(question));
          if (!isTouched) {
            dispatch(setTouchedQuestionName(question.initialKey));
          }
        }}
      />
      {chosenColor && (
        <ColorWrapper
          noImage={!chosenColor.image}
          bgColor={chosenColor.hex_code}
        >
          {chosenColor.image && <Image src={chosenColor.image} />}
          <BottomContainer>
            <Title color={labelColor}>{chosenColor.name}</Title>
            <Row>
              <ColorCode color={labelColor}>
                {chosenColor.code ? chosenColor.code : ''}
              </ColorCode>
              <ColorCollection color={labelColor}>
                {chosenColor.collection ? chosenColor.collection : ''}
              </ColorCollection>
            </Row>
          </BottomContainer>
        </ColorWrapper>
      )}
      {(showClear || reserveClear) && onClear && (
        <ClearValueButton
          onClear={onClear}
          pwId={pwId + '_clear'}
          hidden={!showClear}
          alignCenter
        />
      )}
    </Container>
  );
};

export default ColorInput;
